<template>
    <!-- A genetic health report is made from a kit's or upload's DNA results: where those are up to,
         in place of reports to see or order -->
    <KitPendingNotice v-if="uploadPending" product="Genetic health reports"
        title="Genetic health reports are available once your upload is tested"
        failed-title="Genetic health reports need an upload with results" />
    <KitPendingNotice v-else product="Genetic health reports"
        title="Genetic health reports are available once your kit finishes"
        failed-title="Genetic health reports need a kit with results" />
</template>

<script setup>
import KitPendingNotice from "@/components/kit/KitPendingNotice.vue";
import { useAncestryKit } from "@/composables/useAncestryKit";

const { uploadPending } = useAncestryKit();
</script>
